import React from "react"
import {useTranslation} from "react-i18next"

import {IonButton, IonIcon, useIonAlert} from "@ionic/react"
import {keyOutline, keySharp} from "ionicons/icons"
import {useHistory} from "react-router";
import Person from "@customTypes/Person";

interface props {
    person: Person
}

const ListItemButtonKeys: React.FC<props> = ({ person }) => {

    const { t } = useTranslation()
        , history = useHistory()
        , [presentAlert] = useIonAlert()
        , keysCount: number = person.counts?.keys || 0
        , translationKey: string = "people.alerts." + (keysCount ? 'keys' : 'no_keys')

    const alertMessage = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t(translationKey + '.header'),
            message: t(translationKey + '.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToPersonKeys = (ev: any) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (keysCount) {
            return history.push('/people/' + person.id + '/keys')
        }

        alertMessage(ev).then()
    }

    return (
        <IonButton color={keysCount > 1 ? "secondary" : (keysCount > 0 ? "medium" : "light")}
                   fill="clear"
                   shape="round"
                   onClick={ (ev) => goToPersonKeys(ev) }
                   size="large"
                   style={{ 'fontSize': '1rem' }}
        >
            <IonIcon slot="start" ios={keyOutline} md={keySharp} />
            {keysCount || '-'}
        </IonButton>
    )
}

export default ListItemButtonKeys